import { useCallback, useEffect, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { sentry } from 'legacy/utils/sentry'

import { type Employee } from '../../domain/Employee'
import { getCarrierEmployees } from '../../use-cases/getCarrierEmployees'

export function useGetCarrierEmployees(carrierUUID: string) {
  const [employees, setEmployees] = useState<Array<Employee>>([])
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Initial)

  const fetchEmployees = useCallback(async (uuid: string, abortController?: AbortController) => {
    setRequestStatus(RequestStatus.Pending)

    try {
      const result = await getCarrierEmployees(uuid, abortController)
      setEmployees(result)
      setRequestStatus(RequestStatus.Done)
    } catch (error) {
      if (!abortController?.signal.aborted) {
        sentry.log(error)
        setRequestStatus(RequestStatus.Error)
      }
    }
  }, [])

  useEffect(() => {
    const abortController = new AbortController()

    fetchEmployees(carrierUUID, abortController)

    return () => {
      abortController.abort()
    }
  }, [carrierUUID, fetchEmployees])

  return { employees, fetchEmployees, requestStatus }
}
